import { Component, Input } from '@angular/core';
import { RouterModule } from '@angular/router';
import { NgIcon, provideIcons } from '@ng-icons/core';
import { SvgIconComponent } from 'angular-svg-icon';

@Component({
  selector: 'app-sidebar-item',
  templateUrl: './sidebar-item.component.html',
  styleUrl: './sidebar-item.component.scss',
  imports: [SvgIconComponent, RouterModule],
})
export class SidebarItemComponent {
  @Input() icon: string = '';
  @Input() label: string = '';
  @Input() route: string | any[] = '';

  constructor() {}
}
